import api from "./api";

export const activityService = {
  getOnlineSalons: () => api.get("/activities/online-salons"),
  getStaffActivities: () => api.get("/activities/staff-activities"),
  heartbeat: () => api.post("/activities/heartbeat"),
};
